import { useState } from 'react'
import { MenuIcon } from '~/components/icons'
import { signUpClickEvent } from '../HeaderClickEvents/Events'
import { MobileMenu } from '../MobileMenu'
import { MainLogoIcon } from '~/components/icons/logos'
import { setPremiumWith3AutoApplyCreditsFlag } from '~/helper'
import { Button } from '~/components/general/Button'
import classNames from 'classnames'
import { trackEvent } from '~/utils/tracking'
import { TypeNavigationLink } from '~/types/contentful'

type MobileHeaderProps = {
  navItems: TypeNavigationLink<'WITHOUT_UNRESOLVABLE_LINKS', string>[]
  userAuthorized: boolean
  isDarkBg?: boolean
  isFixed?: boolean
  createAccountLink: string
}

const onSignUpClick = () => {
  if (window.location.href.includes('total-job-search')) {
    setPremiumWith3AutoApplyCreditsFlag()
  }
  signUpClickEvent()
}

const MobileHeader = ({
  navItems,
  userAuthorized,
  isDarkBg,
  isFixed,
  createAccountLink,
}: MobileHeaderProps) => {
  const [isOpened, setOpening] = useState<boolean>(false)

  const openMenu = () => {
    trackEvent('open_website_menu')
    setOpening(true)
  }
  const closeMenu = () => setOpening(false)

  return (
    <>
      <div className="hidden max-xl:flex items-center justify-between h-full">
        <Button
          className={'!px-0 !py-2 !lg:w-64 !md:w-36 !w-32'}
          iconRight={
            <MainLogoIcon
              className={classNames(
                'w-full max-w-40',
                !isFixed && isDarkBg ? 'text-white' : 'text-black',
              )}
            />
          }
          type={'link'}
          color={'link'}
          target={'_self'}
          href={'/'}
        />

        <div className="hidden items-center max-xl:flex gap-1">
          {userAuthorized ? (
            <Button
              text={'Dashboard'}
              type={'link'}
              href={'/app'}
              className={'w-fit !text-s !py-2 !px-4'}
            />
          ) : (
            <Button
              text={'Sign Up'}
              type={'link'}
              onClick={onSignUpClick}
              href={createAccountLink}
              className={'w-fit !text-s !py-2 !px-4'}
            />
          )}

          <Button
            iconRight={<MenuIcon className="text-neutral-90" />}
            onClick={openMenu}
            color={'transparent'}
            className={'w-fit !p-0 hidden max-md:ml-0 max-xl:flex max-xl:ml-4'}
          />
        </div>
      </div>

      {isOpened && (
        <MobileMenu menuData={navItems} closeMenu={closeMenu} userAuthorized={userAuthorized} />
      )}
    </>
  )
}

export default MobileHeader
